import React from "react";
import { styled, SxProps } from "@mui/material/styles";
import { EmtTheme } from "../types";

export type EmtNavLinkProps = {
  children?: React.ReactNode;
  sx?: SxProps;
  className?: string;
  onClick?: () => void;
  notification?: boolean;
  notificationSx?: SxProps;
  nonce?: string;
};

const StyledA = styled("a")(({ theme }: { theme?: EmtTheme }) => ({
  position: "relative",
  color: theme?.palette.common.black,
  textDecoration: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  "& :first-of-type": {
    color: theme?.palette.common.black,
    textDecoration: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  "& .MuiChip-colorPrimary": {
    "& .MuiChip-label": {
      color: theme?.palette.common.white,
    },
  },
  "&:hover, &.active": {
    "& *": {
      color: theme?.palette.primary.main,
    },
  },
  [theme?.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: "2px",
    "& .emt-icons": {
      color: theme?.palette.greyGradient.light,
      fontSize: "18px",
    },
    "&:hover": {
      "& .emt-icons": {
        color: theme?.palette.primary.main,
      },
      "& *": {
        fontWeight: "400",
        color: theme?.palette.primary.main,
      },
    },
    "&.active": {
      "& .emt-icons": {
        color: theme?.palette.primary.main,
      },
      "& *": {
        fontWeight: "700",
        color: theme?.palette.greyGradient.light,
      },
    },
  },
}));
const Notification = styled("span")(({ theme }) => ({
  position: "absolute",
  top: "4px",
  right: "11px",
  width: "5px",
  height: "5px",
  backgroundColor: theme.palette.error.main,
  boxShadow: `0 0 0 1px ${theme.palette.common.white}`,
  borderRadius: "100%",
}));

export const EmtNavLink: JSX.Element & any = React.forwardRef<
  HTMLSpanElement,
  EmtNavLinkProps
>((componentProps, ref) => {
  const { children, notification, notificationSx, ...rest } = componentProps;
  return (
    <StyledA {...rest} ref={ref as React.ForwardedRef<HTMLAnchorElement>}>
      <>
        {children}
        {notification && <Notification sx={notificationSx} />}
      </>
    </StyledA>
  );
});

EmtNavLink.displayName = "EmtNavLink";
